// extracted by mini-css-extract-plugin
export default {"root":"ClubsPage_root__XP5qU","header":"ClubsPage_header__QWvaN","body":"ClubsPage_body__1cTpI"};